<template>
  <div class="language-switcher">
    <div class="language-select gap-1" @click="toggleDropdown">
      <img :src="currentFlag" alt="flag" class="flag-icon" />
      {{ currentLabel }}
      <span class="arrow">&#9662;</span>
    </div>
    <div v-if="dropdownOpen" class="dropdown">
      <div v-for="lang in languages" :key="lang.code" class="option" @click="selectLanguage(lang.code)">
        <img :src="lang.flag" alt="flag" class="flag-icon" />
        {{ lang.label }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { ref, computed, watch } from 'vue';

const { locale } = useI18n({ useScope: 'global' });
const store = useStore();

const languages = [
  { code: 'en', label: 'EN', flag: '/flags/en.png' },
  { code: 'uk', label: 'UA', flag: '/flags/ua.png' },
  { code: 'pl', label: 'PL', flag: '/flags/pl.png' },
  { code: 'cz', label: 'CZ', flag: '/flags/cz.png' }
];

const currentLang = ref(localStorage.getItem('lang') || store.state.lang.language || 'uk');
const dropdownOpen = ref(false);

const currentFlag = computed(() => languages.find(l => l.code === currentLang.value)?.flag);
const currentLabel = computed(() => languages.find(l => l.code === currentLang.value)?.label);

const selectLanguage = (lang) => {
  currentLang.value = lang;
  dropdownOpen.value = false;
};

const toggleDropdown = () => {
  dropdownOpen.value = !dropdownOpen.value;
};

watch(currentLang, (lang) => {
  locale.value = lang;
  store.commit('lang/SET_LANGUAGE', lang);
  localStorage.setItem('lang', lang);
});
</script>

<style scoped>
.language-switcher {
  position: relative;
  display: inline-block;
  font-size: 1rem;
}

.language-select {
  display: flex;
  align-items: center;
  background: #f9f9f9;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  padding: 0.3rem 0.6rem;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.language-select:hover {
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.flag-icon {
  width: 20px;
  height: 14px;
  margin-right: 0.5rem;
  object-fit: cover;
}

.arrow {
  margin-left: auto;
  font-size: 0.8rem;
}

.dropdown {
  position: absolute;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-top: 0.2rem;
  z-index: 10;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.option {
  padding: 0.3rem 0.6rem;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.option:hover {
  background-color: #f0f0f0;
}
</style>